import { getVerifyState } from '../../lib/verify-states.js';

/**
 * ScanResultBadge — pill showing the verify-state of a single scan row.
 *
 * Uses the same 4-state vocabulary the public verify endpoint does:
 * verified / under_review / no_longer_employed / unknown.
 */
export function ScanResultBadge({ result }) {
  const state = getVerifyState(result);
  return (
    <span className={`scan-result scan-result-${state.key}`}>
      {state.label}
    </span>
  );
}
